// import { DesignValue, LayoutTemplate } from "@jd/workplace-designer-inner";

export interface WidgetResourceJUE {
  filename: string;
  jsUrl: string;
  renderProps?: unknown;
  customConfig?: any;
}

export const mockValueV1: any = [
  // {
  //   id: '1',
  //   type: 'Column1',
  //   columns: 1,
  //   children: [
  //     {
  //       id: 'gJHYAi0cAOjo9N7unFLfh_rD_8PJ',
  //       configs: {
  //         isNativeHead: '0',
  //         jumpConfig: {
  //           en_US: {
  //             icon: 'https://eefs-pre.jd.com/res/download/QhZbHoC8SYIBSsRQgNNbpBT8O.png?appKey=469ceef73b89853d',
  //             text: '全部',
  //             jumpUrlDesk: 'http://me.jd.com',
  //             jumpUrl: '',
  //           },
  //           zh_CN: {
  //             icon: 'https://eefs-pre.jd.com/res/download/QhZbHoC8SYIBSsRQgNNbpBT8O.png?appKey=469ceef73b89853d',
  //             text: '全部',
  //             jumpUrlDesk: 'http://me.jd.com',
  //             jumpUrl: '',
  //           },
  //         },
  //       },
  //       previewUrl: null,
  //       cardName: '导航',
  //       cardIcon:
  //         'http://test.eefs.jd.com/res/download/yHe9UDcul52sVOo3YvPsRgShS.png?appKey=469ceef73b89853d',
  //       cardId: 'gJHYAi0cAOjo9N7unFLfh',
  //       cardType: '02',
  //       templateId: 'template9I54SYsx',
  //       jsUrl: 'http://127.0.0.1:8086/jue-template/js/template9I54SYsx/template9I54SYsx.js',
  //       isNativeHead: true,
  //       jumpUrl: 'http://jd.com',
  //       resource: {
  //         filename: 'template9I54SYsx',
  //         jsUrl: 'http://127.0.0.1:8086/jue-template/js/template9I54SYsx/template9I54SYsx.js',
  //       },
  //       layout: {
  //         height: 59,
  //         contentHeight: 59,
  //       },
  //       props: {
  //         name: '',
  //         icon: '',
  //         redirectUrl: '',
  //       },
  //       canAddWidget: true,
  //     },
  //   ],
  // },
  // {
  //   id: '2',
  //   type: 'Column1',
  //   columns: 1,
  //   children: [
  //     {
  //       cardName: '轮播图',
  //       previewUrl: null,
  //       resource: {
  //         filename: 'templateasgpr3E4',
  //         customConfig: {
  //           bannerConfig: [
  //             {
  //               imgUrl1:
  //                 'http://test.eefs.jd.com/res/download/FBAZLW0Shy58dslhkmdrXzPtj.jpeg?appKey=469ceef73b89853d',
  //               sort: 1,
  //               jumpUrl: 'http://jd.com',
  //             },
  //             {
  //               imgUrl1:
  //                 'http://test.eefs.jd.com/res/download/TMxYioVbVs2m0AAX3Ju2FrpEx.jpeg?appKey=469ceef73b89853d',
  //               sort: 2,
  //               jumpUrl: 'http://baidu.com',
  //             },
  //           ],
  //         },
  //         jsUrl: 'http://127.0.0.1:8086/jue-template/js/templateasgpr3E4/templateasgpr3E4.js',
  //       },
  //       cardType: '02',
  //       isNativeHead: false,
  //       templateId: 'templateasgpr3E4',
  //       jsUrl: 'http://127.0.0.1:8086/jue-template/js/templateasgpr3E4/templateasgpr3E4.js',
  //       jumpUrl: 'jdme://jm/biz/appcenter/202104080991',
  //       props: {
  //         redirectUrl: '',
  //         name: '',
  //         icon: '',
  //       },
  //       canAddWidget: true,
  //       layout: {
  //         height: 200,
  //         contentHeight: 164,
  //       },
  //       cardIcon:
  //         'http://test.eefs.jd.com/res/download/0c7AloTQyBMPYiWnJtJYkJCJk.png?appKey=469ceef73b89853d',
  //       cardId: 'BF2JMdbf9TGasyCiY4o7L',
  //       id: 'BF2JMdbf9TGasyCiY4o7L_2M-wPX',
  //       configs: {
  //         isNativeHead: '1',
  //         jumpConfig: {
  //           en_US: {
  //             jumpUrlDesk: 'jdme://jm/biz/appcenter/202104080991',
  //             jumpUrl: 'jdme://jm/biz/appcenter/202104080991',
  //           },
  //           zh_CN: {
  //             jumpUrlDesk: 'jdme://jm/biz/appcenter/202104080991',
  //             jumpUrl: 'jdme://jm/biz/appcenter/202104080991',
  //           },
  //         },
  //       },
  //     },
  //   ],
  // },
  // {
  //   id: '3',
  //   type: 'Column2',
  //   columns: 6,
  //   children: [
  //     {
  //       id: `card2`,
  //       cardId: 'mf',
  //       templateId: 'mf',
  //       jsUrl: 'http://127.0.0.1:9624/bundle.js',
  //       cardType: '03',
  //       cardName: '我的工具',
  //       cardIcon: 'https://storage.360buyimg.com/jd.jme.file.cache/wodegongju1.png',
  //       jumpUrl: '',
  //       resource: {
  //         filename: 'designerDemo.jue',
  //         jsUrl: 'http://127.0.0.1:8086/bundle.js',
  //       },
  //       layout: {
  //         gridArea: '1/1/2/4',
  //       },
  //     },
  //     {
  //       id: `card3`,
  //       cardId: 'designerDemo',
  //       templateId: 'designerDemo',
  //       cardType: '02',
  //       cardName: '我的工具',
  //       jsUrl: 'http://127.0.0.1:8086/jue-template/js/designerDemo/designerDemo.js',
  //       cardIcon: 'https://storage.360buyimg.com/jd.jme.file.cache/wodegongju1.png',
  //       jumpUrl: '',
  //       resource: {
  //         filename: 'designerDemo',
  //         jsUrl: 'http://127.0.0.1:8086/jue-template/js/designerDemo/designerDemo.js',
  //       },
  //       layout: {
  //         gridArea: '1/4/2/7',
  //       },
  //     },
  //   ],
  // },
];

export const layoutTemplate: any = [
  {
    type: "Column1",
    title: "单栏布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/90b667862.svg",
    columns: 1,
    defaultGridId: "default",
    gridSettingHidden: true,
    gridAreas: [
      {
        value: "default",
        gridArea: ["1/1/1/1"]
      }
    ]
  },
  {
    type: "Column2",
    title: "两栏布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/76dab87f9.svg",
    columns: 6,
    defaultGridId: "1:1",
    gridAreas: [
      {
        value: "1:2",
        label: "1:2",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/7e5fedaa8.svg",
        gridArea: ["1/1/2/3", "1/3/2/7"]
      },
      {
        value: "1:1",
        label: "1:1",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/ccb2520c7.svg",
        gridArea: ["1/1/2/4", "1/4/2/7"]
      },
      {
        value: "2:1",
        label: "2:1",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/cf13278d6.svg",
        gridArea: ["1/1/2/5", "1/5/2/7"]
      }
    ]
  },
  {
    type: "Column3",
    title: "三栏布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/5e387f869.svg",
    columns: 3,
    defaultGridId: "default",
    gridSettingHidden: true,
    gridAreas: [
      {
        value: "default",
        gridArea: ["1/1/2/2", "1/2/2/3", "1/3/2/4"]
      }
    ]
  },
  {
    type: "Column4",
    title: "双栏混合布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/fe899a547.svg",
    columns: 6,
    defaultGridId: "2:1",
    gridAreas: [
      {
        value: "1:2",
        label: "1:2",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/4802daf9f.svg",
        gridArea: ["1/1/3/3", "1/3/2/7", "2/3/3/7"]
      },
      {
        value: "1:2-flip",
        label: "1:2水平翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG2SURBVHgB7dxBSsNAFIfxN7GCSJC6c1m8mGfwBOoNPI94Bj2B2mVXkoIVoWmeibixJkwWpc1/8v127aKQztcwDckLj89+5V7du9nUAB3zLGS34eGperu8CLPjiQEy1qXZ66IqMjMnXsj5bXaaGSCMgCFtpwG7Afu104CDAfvFFgLSotcf8pP6r15el87pdVDKjdny02z19ff9VNar6/i2Rc/AZ6fEO0STI7Pz/P/7qaxX1/FtiwbcfBCGqS3UlNarzw+RPTCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkRQN2ntQcrE1loxcN+P2DL2qImhPLcmWjF30mrnkmKfZcEnAo7IEhjYAhjYAhjbkQovrOTUgdcyFE9Z2bkDrmQgjjxMIeGOIIGNIIGNIIGNIIGNIIGNIIGNJaA+YWYKhoDZjr41DBFgLSCBjSCBjSCBjSCBjSCBjSmAshrG3cQUrr1WecA3MhRHXNhUhlvfrOvWAuRGLGtl7sgSGNgCGNgCGNgCGNgCGtGS1QlKUBUtblz33r84m7X78s/KZ+OTNARxHc774BaeZptVNoli8AAAAASUVORK5CYII=",
        gridArea: ["1/5/3/7", "1/1/2/5", "2/1/3/5"]
      },
      {
        value: "1:1",
        label: "1:1",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/233d90a54.svg",
        gridArea: ["1/1/3/4", "1/4/2/7", "2/4/3/7"]
      },
      {
        value: "1:1-flip",
        label: "1:1水平翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG5SURBVHgB7dxBahNhGMfhd2IEkSB157J4Mc/gCdQbeB7xDHoCtcuuJAUrQtN8JuKmbcLMwGTKH55nlyyyePOb8CVk3u7z1/amte3HVnVWkONi0S3ed5++bH+8ftWdP10WxLjZVH2/3K4XVU28xPnf7NmiIJiAiTZpwK1gXpMG3BXMyxGCaL2/P6ye7b7qrXal+3gdZHNbdfW76vrP3efNcZxjc7yv9xP4xXNDH2P5pOrl6uHz5jjOsTne1xvw/oUY51Co5jjekAveGZhoAiaagIkmYKIJmGgCJpqAiSZgogmYaAImmoCJJmCiCZhoAiaagInWG3Bzp+Zot9tiJr0B//zlDRljf8FfXRcz6b0nbn9PUt99SfBYnIGJJmCiCZho9kJMbOg+A6ZhL8TEhu4zYBr2QpyAC34+zsBEEzDRBEw0ARNNwEQTMNEETLSDAfsLMCkOBux3eFI4QhBNwEQTMNEETDQBE03ARLMX4gQOrSEwx/GGrHOwF2Jix/ZCmOM4Q/dr2AsxE3M8DWdgogmYaAImmoCJJmCi7VcYrDebgig3m3//W79Yttbefrts73YPzwtyrLvWPvwFGjhptQ5MtSgAAAAASUVORK5CYII=",
        gridArea: ["1/4/3/7", "1/1/2/4", "2/1/3/4"]
      },
      {
        value: "2:1",
        label: "2:1",
        img:
          "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/b99e39385.svg",
        gridArea: ["1/1/3/5", "1/5/2/7", "2/5/3/7"]
      },
      {
        value: "2:1-flip",
        label: "2:1水平翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGsSURBVHgB7d1BSsNQFEbhmxhBJEidOSxuzDW4AnUHrkdcg65A7bAjScGK0DTXRJxYU14GpeW/Od+sGRQeOQ2vobnNHp/9yr25d7OJATpmeZbfZg9PzdvlRTY9LgyQsarNXudNlZs58ULOb7OT3ABhBAxpOw3YDdivnQacGbBfbCEgLXn/oTxpv+qVbenil9d6bbb4NFt+/T0eZX3RbDtfm5JX4LPTGCe3ODI7L/8fj7K+aLadr03JgLs3iqIv1Ejri2bIhYU9MKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQRMKQlA/ZAT2quG0MwyYDfP2Kc+O6DuFgagkk+E9c9k5R6Lgk4FPbAkEbAkEbAkDb6uRDQNvq5ENA2+rkQ0MYeGNIIGNIIGNIIGNIIGNIIGNIIGNJ6A+bPWqCiN2Du90MFWwhII2BII2BII2BII2BII2BIG/1ciEjri2bIOIfRz4WIsr5ohs7xGP1cCOZeaGMPDGkEDGkEDGkEDGkEDGndqISqrg2Qsqp/frc+K9z9+mXuN+3LqQE6qsz97hvKe2m1S3yqIAAAAABJRU5ErkJggg==",
        gridArea: ["1/3/3/7", "1/1/2/3", "2/1/3/3"]
      }
    ]
  },
  {
    type: "Column5",
    title: "三栏混合布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/8ad8ef89b.svg",
    columns: 3,
    defaultGridId: "default",
    gridAreas: [
      {
        value: "default",
        label: "默认布局",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHGSURBVHgB7dxBTsJAFIfx14oJUaK4c0m8mGfwBOoNPI/xDHoClSUrA4kYE0qfrboR20wXBObf+X47WJAM/WgGwrzs4ckv3cs7NxsboGOaZ/lNdv9Yvl6cZ5PDgQEyVoXZy6yc52ZOvJDz2+w4N0AYAUPaVgN2A3ZrqwFnBuwWWwhIC/7+MBpWX/VGVencXqNUrM0WH2bLz7/Pq1+3tnVtCt6BT46IN2aDA7Oz0f/n1a9b27o2BQOuXwhxawq1D9etyweQPTCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkETCkBQN2TmpGb11asoIBv72n/QbFrr7BLJaWrOCZuPpMUuhcErAv7IEhjYAhjYAhLYm5EG0zBo6HP0e3+7i2VCQxF6JtxsBpj9eWimTmQvR1dkIt5cEz7IEhjYAhjYAhjYAhjYAhjYAhjYAhrTFg/gIMFY0BM5AdKthCQBoBQxoBQxoBQxoBQxoBQ1oycyGaRgOwtrh1GeeQxFyIttkJrC1eXeddJD0XgrXpYw8MaQQMaQQMaQQMaQQMafVIgXlRGCBlVXz/b306cPer55lfVw8nBuiYZ+63X0atf5MWV6FVAAAAAElFTkSuQmCC",
        gridArea: ["1/1/1/3", "1/3/3/4", "2/1/3/2", "2/2/3/3"]
      },
      {
        value: "horizontal-flip",
        label: "水平翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHRSURBVHgB7dxRSgJRFIfxM5NBhIS99ShtrDW0gmoHrSdaQ62g8tGnUMgIHOfkRC9NI9eHQf2f+/3eFBGu8zFcxXuKx2e/cq/v3WxkgI5JWZS3xcNT/XZ5UYyPBwbIWFZmr9N6Vpo58ULOb7Oj0gBhBAxpvQbsBuxWrwEXBuwWWwhIS/7+MDxZf9UbrksXvb1WK7P5p9ni6+/z6uuKbtN1a0vegc9OtS/y4MjsfPj/efV1RbfpurUlA27eSF1XqBHWFd02Nxj2wJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJCWbcDOCdSDt6rTr8k24PeP7T4g7Edzg5kv0q/LdiZPc9Yqdd4Kh489MKQRMKQRMKRluweOMBci8syL3uZCRBVhLkTkmRe9zYWIKspciMgzL5gLgfAIGNIIGNIIGNIIGNIIGNIIGNI6A+avslDRGTCDy6GCLQSkETCkETCkETCkETCkETCkJQOOMD+h6/h8lLkQua2tLRmw+vyETfMFIsyFyHFtbckzcVHnJ0SeC5HTzAv2wJBGwJBGwJBGwJBGwJDWHL2fVZUBUpbVz//WJwN3v36Z+s364dgAHbPC/e4bOLV/kjLz64EAAAAASUVORK5CYII=",
        gridArea: ["1/2/2/4", "1/1/3/2", "2/3/3/4", "2/2/3/3"]
      },
      {
        value: "vertical-flip",
        label: "垂直翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHESURBVHgB7d1NTsJQFIbh04qJMcTgzCFxY67BFag7cD3GNegKVIaMDCRiTCg9UuMEKLkdENLv3PeZ2YHJpS/N5aeH4vnVb9zrRzcbGaBjUhblffH0Un9cXxXj04EBMpaV2fu0npVmTryQ89/sqDRAGAFD2kEDdgOO66ABFwYcF1sISEu+/zA8W7/UG65LF768Viuz+bfZ4mfzOGvrr33r2pa8Al+ca5/gxuDE7HK4e5y19de+dW1LBtz8owjaTiZr67cuT0D2wJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJBGwJCWDNiD3Km5qnePRV5bLpIBf37pP0BNqPPF7vHIa8tF8p645p6k1H1JqiKvLRfsgSGNgCGNgCEti7kQkXWdnxBVFnMhIus6PyGqbOZCRJbzBYY9MKQRMKQRMKQRMKQRMKQRMKQRMKS1BsyPtUBFa8B88AYVbCEgjYAhjYAhjYAhjYAhjYAhLZu5EJFFnXnRZeRBFnMhIos686LrvIus50JElst5Yw8MaQQMaQQMaQQMaQQMac1IgVlVGSBlWf19b30ycPfbt6nfrf8cG6BjVrg//AJYtn+S2l8NpAAAAABJRU5ErkJggg==",
        gridArea: ["2/1/3/3", "1/3/3/4", "1/1/2/2", "1/2/2/3"]
      },
      {
        value: "horizontal-vertical-flip",
        label: "水平+垂直翻转",
        img:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAA8CAYAAADGxTD9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHGSURBVHgB7d1BSsNQEIfxSawgUqTuXBYv5hk8gXoDzyOeQU+gdtmVtGBFaJoxT9yYBOIilP7nfb+dQYSpH+Vpm2nx+OxX7vW9m80M0LEoi/K2eHiq3y4vivnxxAAZ28rsdVmvSjMnXsj5bXZWGiCMgCFt1IDdgP0aNeDCgP3iCAFpg/9/mJ40f+pNm9JFn16rndn602zz9fe6+lxJjrO1DT4Dn51qPxCTI7Pzafe6+lxJjrO1DQacfpC6vl9mhLmS3GbrfI8BwggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0ggY0rIN2IPcgbqru9ciz9aWbcDvH/97gA5ZCnW96V6PPFtbtjt50r1WQ/dbqYo8WxtnYEgjYEgjYEjL9gwcYXdCZKPthYgqwu6EyEbbCxFVlN0JkbEXAuERMKQRMKQRMKQRMKQRMKQRMKT1BsyHtUBFb8C8QAUVHCEgjYAhjYAhjYAhjYAhjYAhbTDgCDsGIu9OiGyUvRDqOwYi706IbLS9EFF3DOS0OyEyzsCQRsCQRsCQRsCQRsCQlm69X1WVAVK21c/71hcTd79+WfpN8+XcAB2rwv3uG5QYf5Kc/WbkAAAAAElFTkSuQmCC",
        gridArea: ["2/2/3/4", "1/1/3/2", "1/3/2/4", "1/2/2/3"]
      }
    ]
  }
];

export const mobileLayoutTemplate: any = [
  {
    type: "Column1",
    title: "单栏布局",
    displayImage:
      "https://lf-cdn-tos.bytescm.com/obj/static/workplace-builder/1_0_0_1005/images/90b667862.svg",
    columns: 1,
    defaultGridId: "default",
    gridSettingHidden: true,
    gridAreas: [
      {
        value: "default",
        gridArea: ["1/1/1/1"]
      }
    ]
  }
];

export const value = [
  {
    type: "Column1",
    columns: 1,
    id: "Column1-vIWWqN",
    children: [
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "1",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_keRkOy",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR10-1"
        },
        templateId: "Application",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      }
    ]
  },
  {
    type: "Column4",
    columns: 6,
    id: "Column4-zLjdH2",
    children: [
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "2",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_DlivWp",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          layout: {
            height: 421,
            contentHeight: 385
          },
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR9-2"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 421,
          contentHeight: 385
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "3",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_XLXYGL",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR8-3"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "4",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_dxA1sQ",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          appKey: "2Vrs09rW69eDxDSF0GKR7-4",
          interfaceUrl: "https://www.jd.com"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      }
    ],
    gridId: "2:1-flip"
  },
  {
    type: "Column4",
    columns: 6,
    id: "Column4-zLjdH1",
    children: [
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "5",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_DlivWp",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          layout: {
            height: 421,
            contentHeight: 385
          },
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR6-5"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 421,
          contentHeight: 385
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "6",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_XLXYGL",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR5-6"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "7",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_dxA1sQ",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR4-7"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      }
    ],
    gridId: "2:1-flip"
  },
  {
    type: "Column4",
    columns: 6,
    id: "Column4-zLjdH3",
    children: [
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "8",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_DlivWp",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          layout: {
            height: 421,
            contentHeight: 385
          },
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR1-8"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 421,
          contentHeight: 385
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "9",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_XLXYGL",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          interfaceUrl: "https://www.jd.com",
          appKey: "2Vrs09rW69eDxDSF0GKR2-9"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      },
      {
        cardIcon:
          "https://eefs-pre.jd.com/res/download/HorAajf5dz4zJvtHWgNXvzrLk.png?appKey=469ceef73b89853d",
        cardId: "MjdE9rMUue7xOAksvLF3s",
        cardName: "10",
        cardType: "02",
        configs: {
          isNativeHead: "1"
        },
        id: "MjdE9rMUue7xOAksvLF3s_dxA1sQ",
        isNativeHead: false,
        jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
        jumpUrl: "jdme://jm/biz/appcenter/202104080991",
        previewUrl: "",
        resource: {
          filename: "templateAk72wYgG",
          jsUrl: "http://test.storage.jd.com/jd.jme.download/templateAk72wYgG_v5.js",
          appKey: "2Vrs09rW69eDxDSF0GKR3-10",
          interfaceUrl: "https://www.jd.com"
        },
        templateId: "SuperviseHandle",
        layout: {
          height: 200,
          contentHeight: 164
        },
        props: {
          name: "",
          icon: "",
          redirectUrl: ""
        },
        canAddWidget: true
      }
    ],
    gridId: "2:1-flip"
  }
];

export const SuperviseHandleData = {
  titleList: [
    {
      title: "督办",
      tabsList: [
        {
          title: "按进度查看1",
          name: "事件总项",
          total: "100",
          color: ["#E83A34", "#27BB65", "#DADDE2", "YELLOW", "PURLE"],
          data: [
            [
              {
                value: "25项",
                name: "已滞后事项"
              },
              {
                value: "25%",
                name: "滞后率"
              }
            ],
            [
              {
                value: "65项",
                name: "推进中事项"
              },
              {
                value: "65%",
                name: "正常率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ]
          ]
        },
        {
          title: "按来源查看1",
          color: ["#fff", "#eee", "#ccc"],
          name: "事件总项",
          total: "100",
          data: [
            [
              {
                value: "25项",
                name: "已滞后事项"
              },
              {
                value: "25%",
                name: "滞后率"
              }
            ],
            [
              {
                value: "65项",
                name: "推进中事项"
              },
              {
                value: "65%",
                name: "正常率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ]
          ]
        }
      ]
    },
    {
      title: "领导督办",
      tabsList: [
        {
          title: "按进度查看",
          color: ["#fff", "#eee", "#ccc"],
          data: [
            [
              {
                value: "25项",
                name: "已滞后事项"
              },
              {
                value: "25%",
                name: "滞后率"
              }
            ],
            [
              {
                value: "65项",
                name: "推进中事项"
              },
              {
                value: "65%",
                name: "正常率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ]
          ]
        },
        {
          title: "按来源查看",
          color: ["#fff", "#eee", "#ccc"],
          data: [
            [
              {
                value: "25项",
                name: "已滞后事项"
              },
              {
                value: "25%",
                name: "滞后率"
              }
            ],
            [
              {
                value: "65项",
                name: "推进中事项"
              },
              {
                value: "65%",
                name: "正常率"
              }
            ],
            [
              {
                value: "10项",
                name: "已结办事项"
              },
              {
                value: "10%",
                name: "办结率"
              }
            ],
            [
              {
                value: "30项",
                name: "已结办事项"
              },
              {
                value: "30%",
                name: "办结率"
              }
            ]
          ]
        }
      ]
    }
  ],
  more: {
    name: "更多",
    url: "https://www.more.com"
  }
};

// export const jueRenderHost: RenderHostWithWidgetResource<WidgetResourceJUE> = {
//   onRender: (param) => {
//     console.log('onRender jue', { param });
//     if (!param.resource.filename) {
//       return <span>No jue filename provide</span>;
//     }
//     return <WidgetJUE {...param.resource} />;
//   },
// };

export const layoutValue: {
  tabs: any[];
} = {
  tabs: [
    {
      id: "tab-pc",
      title: "标签1",
      layouts: [
        {
          type: "Column2",
          columns: 6,
          id: "Column2-PkHzLu",
          children: [
            {
              id: "C413349627_lfD74P",
              cardId: "C413349627",
              templateId: "CalendarWidget",
              cardName: "测试卡片2",
              isNativeHead: true,
              resource: {
                isSystem: true,
                appKey: "calendar_appkey",
                relatedApplicationId: "BGhB8QiRmJ8MKySI5cs0",
                interfaceUrl: "calendar.getScheduleListByDateRange"
              },
              layout: {
                height: 200,
                contentHeight: 164
              },
              props: {
                name: "",
                icon: "",
                redirectUrl: ""
              },
              canAddWidget: true
            },
            {
              id: "C413349627_fPO2js",
              cardId: "C413349627",
              templateId: "Inform",
              cardName: "测试卡片2",
              isNativeHead: false,
              resource: {
                relatedApplicationId: "BGhB8QiRmJ8MKySI5cs0"
              },
              layout: {
                height: 200,
                contentHeight: 164
              },
              props: {
                name: "",
                icon: "",
                redirectUrl: ""
              },
              canAddWidget: true
            }
          ]
        },
        {
          type: "Column1",
          columns: 1,
          id: "Column1-GbJMpz",
          children: [
            {
              id: "C614994823_8xZ6Ze",
              cardId: "C614994823",
              templateId: "Application",
              cardName: "ccc122",
              isNativeHead: false,
              resource: {
                relatedApplicationId: "ldwVwZlGeikOkN4sM7Vn"
              },
              layout: {
                height: 200,
                contentHeight: 164
              },
              props: {
                name: "",
                icon: "",
                redirectUrl: ""
              },
              canAddWidget: true
            }
          ]
        }
      ]
    },
    {
      id: "tab-Xi4znFYHhHyldepH4j4Fr}",
      title: "新页签",
      layouts: [
        {
          type: "Column1",
          columns: 1,
          id: "Column1-ddFlSI",
          children: [
            {
              id: "C023768125_09yfHr",
              cardId: "C023768125",
              templateId: "Inform",
              cardName: "测试卡片1",
              isNativeHead: false,
              resource: {
                relatedApplicationId: "4LKb8hJWgm1G5pmGgPtH"
              },
              layout: {
                height: 200,
                contentHeight: 164
              },
              props: {
                name: "",
                icon: "",
                redirectUrl: ""
              },
              canAddWidget: true
            }
          ]
        }
      ]
    },
    {
      id: "tab-k3ly5v_sd2LdJGAjWppvX}",
      title: "新页签",
      layouts: []
    }
  ]
};
